import { useContext, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { wrapThunkAction } from 'redux/utils';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'redux/store';
import { getSessionAvailability } from 'redux/actions/mentorship-program-connections';
import { hasSessionAvailabilityLoadedForParams } from 'redux/selectors/mentorship-program-sessions';

import { css } from '@emotion/react';
import { quarterSpacing } from 'styles/global_defaults/scaffolding';

import MentoringProgramContext from 'athena/components/mentoring-program/context';
import useConnection from 'athena/hooks/use-connection';
import TimeSlotColumn from './time-slot-column';

import { useAvailabilityCalendarContext } from './availability-calendar-context';

export const TIME_SLOT_COLUMN_HEIGHT = 150;

const styles = (columns) => css`
  display: grid;
  grid-template-columns: repeat(${columns}, 1fr);
  justify-items: center;
  gap: ${quarterSpacing}px;
  height: ${TIME_SLOT_COLUMN_HEIGHT}px;
  overflow-y: auto;
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none;
  }
`;

const AvailabilityCalendarGrid = () => {
  const {
    startDateForCurrentWeek,
    numberOfDays,
    getRange,
  } = useAvailabilityCalendarContext();
  const dispatch = useAppDispatch();
  const range = getRange();

  const { mentoringProgram } = useContext(MentoringProgramContext);
  const { id: mentorshipProgramId, mentorshipProgramEnrollment } = mentoringProgram || {};
  const { connectionId } = useConnection(mentorshipProgramEnrollment);

  const { watch } = useFormContext();
  const duration = watch('duration');
  const selectedDate = watch('scheduledDate');

  const hasBeenLoaded = useSelector(hasSessionAvailabilityLoadedForParams({
    mentorshipProgramConnectionId: connectionId,
    mentorshipProgramId,
    meetingDays: range,
    meetingDuration: duration,
  }));

  useEffect(() => {
    if (hasBeenLoaded) return;
    wrapThunkAction(
      dispatch(
        getSessionAvailability({
          mentorshipProgramConnectionId: connectionId,
          mentorshipProgramId,
          meetingDays: range,
          meetingDuration: duration,
          selectedDate,
        }),
      ),
    );
  }, [startDateForCurrentWeek]);

  return (
    <div className='availability-calendar-grid my-2 mx-1' css={styles(numberOfDays)}>
      {range.map((day) => (
        <TimeSlotColumn key={day} day={day} />
      ))}
    </div>
  );
};

export default AvailabilityCalendarGrid;
